<template>
  <v-fade-transition mode="out-in">
    <div v-if="!!(show && room)" class="audioguige-modal pl-md-4">
      <ButtonClose @click.native="onCloseClick" />
      <div class="gradient"></div>
      <v-container fluid fill-height>
        <v-row justify="center" no-gutters>
          <v-col cols="12" sm="10" md="8" lg="6" class="content">
            <h1 class="text-center mb-8">{{ room[$language.current + 'Title'] }}</h1>
            <MarkdownBlock
              v-if="room[$language.current + 'AudioguideText']"
              :text="room[$language.current + 'AudioguideText']"
              :inline="false"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-fade-transition>
</template>

<script>
import ButtonClose from '@/atoms/ButtonClose'
import { MarkdownBlock } from '@monogrid/vue-lib'

export default {
  name: 'AudioguideModal',
  components: { ButtonClose, MarkdownBlock },
  data () {
    return {
      show: false,
      room: null
    }
  },
  mounted () {
    this.$events.on('toggle-audioguide-modal', (state, room) => {
      this.show = state
      this.room = room
    })
  },
  methods: {
    onCloseClick () {
      this.$events.$emit('toggle-audioguide-modal', false, null)
    }
  }
}
</script>

<style lang="scss" scoped>
.audioguige-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $c-pink;
  z-index: 25;
  overflow-y: auto;

  .gradient {
    position: fixed;
    top: 0;
    left: 0;
    width: calc(100% - 20px);
    height: 20vh;
    background: linear-gradient($c-pink 50%, #ffa6b000);

    @include breakpoint ('sm-and-down') {
      width: 100%;
    }
  }

  .content {
    padding: 12% 20px;

    @include breakpoint ('xs-only') {
      padding: 30% 20px;
    }
  }

  h1 {
    line-height: 0.9;
  }
}
</style>
